// Monsor sticky — prijssync
(function () {
  function syncStickyPrice() {
    var stickyBtnText = document.querySelector('.product-sticky-form .monsor-sticky-btn .btn-text');
    if (!stickyBtnText) return;

    function getPrice() {
      // Probeer eerst product-buy-price (ATC knop)
      var buyPrice = document.querySelector('.product-form__submit product-buy-price, product-buy-price');
      if (buyPrice && buyPrice.textContent.trim()) return buyPrice.textContent.trim();

      // Fallback: sticky price element
      var stickyPrice = document.querySelector('#StickyPrice-' + Object.keys(window).find(function(k){ return k.startsWith('StickyPrice') }) );
      if (stickyPrice) return stickyPrice.textContent.trim();

      return '';
    }

    function update() {
      var price = getPrice();
      if (price) stickyBtnText.setAttribute('data-sticky-price', price);
    }

    // Direct uitvoeren
    update();

    // Opnieuw na korte delay voor SSR
    setTimeout(update, 300);
    setTimeout(update, 800);

    // Observer op document voor prijswijzigingen
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.target && m.target.closest && (
          m.target.closest('product-buy-price') ||
          m.target.closest('[id^="BuyButtonPrice"]') ||
          m.target.closest('[id^="StickyPrice"]')
        )) {
          update();
        }
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncStickyPrice);
  } else {
    syncStickyPrice();
  }

})();